import {
  PostUserInterface,
  DeleteUserInterface,
  UpdateUserInterface,
  PostImportFile,
} from '@/data/payload/contracts/UserRequest'

export class UserApiRequest implements PostUserInterface {
  private salesmanCode: string
  private salesmanName: string
  private email: string
  private phone: string
  private password: string
  private passwordConfirmation: string
  private jobPositionId: number
  private dealerGroup: string
  private isActive: string
  private Notes: string
  private Register: string
  private from: string
  constructor(
    salesmanCode: string,
    salesmanName: string,
    email: string,
    phone: string,
    password: string,
    passwordConfirmation: string,
    jobPositionId: number,
    dealerGroup: string,
    isActive: string,
    Notes: string,
    Register: string,
    from: string
  ) {
    this.salesmanCode = salesmanCode
    this.salesmanName = salesmanName
    this.email = email
    this.phone = phone
    this.password = password
    this.passwordConfirmation = passwordConfirmation
    this.jobPositionId = jobPositionId
    this.dealerGroup = dealerGroup
    this.isActive = isActive
    this.Notes = Notes
    this.Register = Register
    this.from = from
  }

  public toJSON() {
    const data = {
      salesman_code: this.salesmanCode,
      salesman_name: this.salesmanName,
      email: this.email,
      phone: this.phone,
      password: this.password,
      password_confirmation: this.passwordConfirmation,
      position: this.jobPositionId,
      dealer_Group: this.dealerGroup,
      is_active: this.isActive.toString(),
      Notes: this.Notes,
      need_register: this.Register,
      from: this.from,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class PostImportRequest implements PostImportFile {
  private fileName: string
  private fileByte: string
  constructor(fileName: string, fileByte: string) {
    ;(this.fileName = fileName), (this.fileByte = fileByte)
  }

  public toJSON() {
    const data = {
      file_name: this.fileName,
      file_byte: this.fileByte,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class UpdateUserRequest implements UpdateUserInterface {
  private salesmanName: string
  private email: string
  private password: string
  private phone: string
  private notes: string
  private dealerGroup: string
  private position: string
  private isActive: boolean
  constructor(
    salesmanName: string,
    email: string,
    password: string,
    phone: string,
    notes: string,
    dealerGroup: string,
    position: string,
    isActive: boolean
  ) {
    this.salesmanName = salesmanName
    this.email = email
    this.password = password
    this.phone = phone
    this.notes = notes
    this.dealerGroup = dealerGroup
    this.position = position
    this.isActive = isActive
  }

  public toJSON() {
    const data = {
      salesman_name: this.salesmanName,
      email: this.email,
      password: this.password,
      phone: this.phone,
      notes: this.notes,
      dealer_group: this.dealerGroup,
      position: this.position,
      is_active: this.isActive,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class UpdateUserDnetRequest implements UpdateUserInterface {
  private password: string
  private sales_code: string
  private email: string
  private phone_number: string
  constructor(
    password: string,
    sales_code: string,
    email: string,
    phone_number: string
  ) {
    this.password = password
    this.sales_code = sales_code
    this.email = email
    this.phone_number = phone_number
  }

  public toJSON() {
    const data = {
      password: this.sales_code,
      sales_code: this.password,
      email: this.email,
      phone_number: this.phone_number,
    }

    return JSON.stringify({
      data,
    })
  }
}

export class DeleteUserRequest implements DeleteUserInterface {
  private ids: number

  constructor(ids: any) {
    this.ids = ids
  }
  public toJSON() {
    const Ids = this.ids
    return JSON.stringify({
      Ids,
    })
  }
}
